import React, { useState } from 'react'
import { NewVideoPlayer } from '../MainEvents/RecommendEventVideos/styles';
import Thumbnail from '../Thumbnail';
import PropTypes from "prop-types";
import { ImageUrl } from '../../utils/constants';
import { withTranslation } from 'react-i18next';
import { t } from 'i18next';
import { FavouriteIcon } from '../../utils/icons';
import { RelatedCard, RelatedCardContainer } from './styles';
import { Circle, CircleContainerNew, Tick } from '../Journeys/styles';

const FitnessRelatedContent = ({video,history,onClickFavoriteRibbon,margin}) => {

  const [onHover, setOnHover]=useState({});

  const onEnterMouse = (id) => {
    setOnHover(id)
  }

  const onLeaveMouse = () => {
    setOnHover(-1)
  };


  return (
    <>
      <RelatedCardContainer margin={margin}>
        <RelatedCard 
          onMouseEnter={() => onEnterMouse(video.id)}
          onMouseLeave={() => onLeaveMouse()}
        >
          <NewVideoPlayer height={'218px'}>
            <Thumbnail
              style={{ cursor: 'default' }} 
              src={`${ImageUrl}/${video?.thumbnail_image || video?.image}`}
              alt={'img'}
              height={'218px'}
            />
          </NewVideoPlayer>
          {onHover === video.id &&
              <div className='educateImageBackground' onClick={()=>history.push(`/education/videos-library/${video.id}`)}>
                <div className="getStarted">
                  {/* {LaunchIcon()} */}
                  {("Get Moving")}
                </div>
              </div>
          }
          <div className='details'>
            <div className='name' title={video?.title}>
              {t(video?.title)}
            </div>
  
            <div className='left-col'>
              <div title={video?.title}>
                <CircleContainerNew style={{ "marginLeft": "15px",marginRight:'20px' }}>
                  <div className="flex">
                    <Circle borderColor="#DA6C74" checked={video?.['view_status']} width={'20px'} height={'20px'} borderWidth={'1px'}>
                      <Tick checked={video?.['view_status']} width={'6px'} height={'11px'} left={'6px'} top={'3px'}/>
                    </Circle>
                  </div>
                  <div className="quiz">
                    {t("Watched")}
                  </div>
                </CircleContainerNew> 
              </div>
              <div style={{cursor:'pointer', display:'flex'}} title={video?.title} onClick={() => {
                onClickFavoriteRibbon(
                  "fitness",
                  video.id,
                  video?.like_status,
                  video?.favorite_status ? 0 : 1,
                  0
                );
                // this.saveImage();
              }}>
                {<FavouriteIcon fill={video?.favorite_status? "#DA6C74" : "none"}/>}
              </div>
            </div>
          </div>
        </RelatedCard>
      </RelatedCardContainer>
    </>
  )
}

FitnessRelatedContent.propTypes = {
  video: PropTypes.object,
  showDescription: PropTypes.bool,
  history: PropTypes.object.isRequired,
  grid: PropTypes.number,
  link: PropTypes.string,
  margin: PropTypes.string,
  bottom: PropTypes.string,
  width: PropTypes.string,
  onClickFavoriteRibbon: PropTypes.func,
  t: PropTypes.func
};
  
export default (withTranslation()(FitnessRelatedContent));